import React, { useState, useEffect } from "react";
import CustomLoader from "../../components/CustomeLoader";
import orderspanish from "../../ulits/images/order-spanish.png";
import { useDispatch, useSelector } from "react-redux";
import { HPICheckAction } from "../../_actions/HPICheck.action";
import { useNavigate } from "react-router";
import { status } from "../../_constants/commonLhd";
import { configs } from "../../config";
import Accordion from 'react-bootstrap/Accordion';
import parse from "html-react-parser";

function OrderSpanish() {
  const [loading, setLoading] = useState(true);
  // const [submitted, setSubmitted] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const HpiData = useSelector((state) => state.HpiCheck);
  const [descripation, setDescripation] = useState({});
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || []; const config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : null;
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(HPICheckAction.getSpanishDescription());
  }, []);

  useEffect(() => {
    if (HpiData?.SpanishDescription_status === status.SUCCESS) {
      setDescripation(HpiData.SpanishDescription_data);
    }
  }, [HpiData.SpanishDescription_data]);

  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    // website: "",
    phoneno: "",
    message: "",
  });

  const validateCredentials = (isValidate) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const PhoneRegex = /^\d{10,12}$/;
    const validObj = {
      message: "",
      isValid: true,
    };

    let isValid = true;
    const retData = {
      name: validObj,
      email: validObj,
      phoneno: validObj,
      // website: validObj,
      message: validObj,
      isValid,
    };

    if (isValidate) {
      const { name, email, phoneno, message } = credentials;

      if (!name) {
        retData.name = {
          message: "Name is required",
          isValid: false,
        };
        isValid = false;
      } else if (name && name.length <= 2) {
        retData.name = {
          message: "Name must be at least 3 characters",
          isValid: false,
        };
        isValid = false;
      }

      if (!email) {
        retData.email = {
          message: "Email is required",
          isValid: false,
        };
        isValid = false;
      } else if (!emailRegex.test(email)) {
        retData.email = {
          message: "Please enter a valid email address",
          isValid: false,
        };
        isValid = false;
      }

      // if (!website) {
      //   retData.website = {
      //     message: "Website Name is required",
      //     isValid: false,
      //   };
      //   isValid = false;
      // }

      if (!phoneno) {
        retData.phoneno = {
          message: "Phone is required",
          isValid: false,
        };
        isValid = false;
      } else if (!PhoneRegex.test(phoneno)) {
        retData.phoneno = {
          message: "Please enter a valid phone number",
          isValid: false,
        };
        isValid = false;
      }

      if (!message) {
        retData.message = {
          message: "Message is required",
          isValid: false,
        };
        isValid = false;
      }

      retData.isValid = isValid;
      return retData;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsValidate(true);
    const error = validateCredentials(true);
    if (error.isValid) {
      dispatch(HPICheckAction.createSpanish(credentials));
      // navigate("/");
      setCredentials({
        name: "",
        email: "",
        phoneno: "",
        message: ""
      })
      window.scrollTo(0, 0)
      setIsValidate(false)
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const error = validateCredentials(isValidate);

  return (
    <>
      {loading ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper order-spanish">
          {descripation &&
            descripation.length > 0 &&
            descripation.map((descripation, index) => (
              <div key={index} className="finance-section">
                <div className="order-title">
                  <div className="container">
                    <h1>{descripation.key}</h1>
                    <div className="row">
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12">
                        <div className="order-spanish-img">
                          <img
                            src={`${configs.localApiUrl}${descripation.image}`}
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12">
                        <div className="order-spanish-text">
                          <p style={{ textAlign: "justify", fontSize: "17px" }}>
                            {parse(descripation.value)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          <div className="european-insurance-form">
            <div className="container">
              <h2>SUBMIT REQUEST FOR SPANISH HPI CHECK</h2>
              {/* {submitted && (
                <p style={{ color: "green" }}>Form submitted successfully!</p>
              )} */}
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={credentials.name}
                    onChange={handleChange}
                    placeholder="NAME"
                    required
                    className="form-control"
                  />
                  {error && error.name.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.name.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={credentials.email}
                    onChange={handleChange}
                    placeholder="EMAIL"
                    required
                    className="form-control"
                  />
                  {error && error.email.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.email.message}
                    </div>
                  )}
                </div>
                {/* <div className="form-group">
                  <input
                    type="text"
                    id="website"
                    name="website"
                    // value={credentials.website}
                    onChange={handleChange}
                    placeholder="WEBSITE"
                    required
                    className="form-control"
                  /> */}
                {/* {error && error.website.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.website.message}
                    </div>
                  )} */}
                {/* </div> */}
                <div className="form-group">
                  <input
                    type="phone"
                    id="phoneno"
                    name="phoneno"
                    value={credentials.phoneno}
                    onChange={handleChange}
                    placeholder="PHONE"
                    required
                    className="form-control"
                  />
                  {error && error.phoneno.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.phoneno.message}
                    </div>
                  )}
                </div>
                <div className="form-group textarea">
                  <textarea
                    id="message"
                    name="message"
                    value={credentials.message}
                    onChange={handleChange}
                    placeholder="MESSAGE"
                    required
                  />
                  {error && error.message.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.message.message}
                    </div>
                  )}
                </div>
                <button
                  className="primary-btn sm"
                  type="SEND MESSAGE"
                  title="SEND MESSAGE"
                  onClick={handleSubmit}
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>
          </div>
          <div className="stm-accordion-single-unit about-faq">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 && (
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>
                        {item.ans}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OrderSpanish;
